<template>
  <div class="content">
    <Header />
    <div class="info">
      <div class="plaha">
        <div class="searchForm flex ui fjcS">
          <div class="col90 prev">
            <span>Название категории</span>
            <input type="text" @keyup="searchSection" />
            <ul>
              <li
                v-for="(item, key) in searchList"
                :data-id="item.id"
                :key="key"
                @click="
                  id = item.id;
                  closeUl();
                "
              >
                {{ item.name }}
              </li>
            </ul>
          </div>
          <div class="col10 forBtn">
            <a href="#!" class="searchBtn">Найти</a>
          </div>
        </div>
      </div>
      <div class="sectionList flex fjcS">
        <div class="form  ">
          <div class="ui flex fWrap fjcS">  
            <div class="row col50">
              <span>Название</span>
              <input type="text" v-model="sName" @keyup="toUrl" />
            </div>
            <div class="row col50 prev small">
              <span>Родительская категория</span>
              <input type="text" @keyup="searchSection" v-model="sParentName" />
              <ul>
                <li
                  v-for="(item, key) in searchList"
                  :data-id="item.id"
                  :key="key"
                  @click="
                    sParentId = item.id;
                    sParentName = item.name;
                    closeUl();
                  "
                >
                  {{ item.name }}
                </li>
              </ul>
            </div>
            <div class="row col50">
              <span>TITLE</span>
              <input type="text" v-model="sTitle" />
            </div>
            <div class="row col50">
              <span>Дополнительная наценка</span>
              <input type="text" v-model="sOverPrice" />
            </div>
            <div class="row col100">
              <span>DESCRIPTION</span>
              <input type="text" v-model="sDescription" />
            </div>

            <div class="row col50">
              <span>Поставщик </span>
              <DropDown
                :list="sailersList"
                :selected="sSailer"
                :itemId="0"
                @dropSelect="setSailer"
              />
            </div>
            <div class="row col50">
              <span>Иконка</span>
              <input
                type="file"
                id="file"
                ref="file"
                accept="image/*"
                v-on:change="handleFileUpload()"
              />
            </div>
            <div class="row col50">
              <span>URL</span>
              <input type="text" v-model="sUrl" />
            </div>
            <div class="row col50">
              <span>URL поставщика</span>
              <input type="text" v-model="sParentUrl" />
            </div>
            <div class="row col100">
              <span>Прикрепить банер</span>
              <div class="dropDown">
                <input type="" />
                <span>Значения</span>
                <ul>
                  <li>Значения</li>
                  <li>Диапазон</li>
                </ul>
              </div>
            </div>
            <div class="row col10">
              <span class="smallFont">0 - 3</span>
              <input type="text" v-model="markup_0_3"/>
            </div>
            <div class="row col10">
              <span class="smallFont">3 -5</span>
              <input type="text" v-model="markup_3_5"/>
            </div>
            <div class="row col10">
              <span class="smallFont">5 - 7</span>
              <input type="text" v-model="markup_5_7"/>
            </div>
            <div class="row col10">
              <span class="smallFont">7 - 10</span>
              <input type="text" v-model="markup_7_10"/>
            </div>
            <div class="row col10">
              <span class="smallFont">10 - 15</span>
              <input type="text" v-model="markup_10_15"/>
            </div>
            <div class="row col10">
              <span class="smallFont">15 - 20</span>
              <input type="text" v-model="markup_15_20"/>
            </div>
            <div class="row col10">
              <span class="smallFont">20 - 25</span>
              <input type="text" v-model="markup_20_25"/>
            </div>
            <div class="row col10">
              <span class="smallFont">25 - 30</span>
              <input type="text" v-model="markup_25_30"/>
            </div>
            <div class="row col10">
              <span class="smallFont">30 - ...</span>
              <input type="text" v-model="markup_30"/>
            </div>
          </div>
          <div class="row col100">
        
            <span>SEO</span>
            <QuillEditor theme="snow" ref="myEditor" toolbar="minimal" contentType="html" v-model:content="seoText" />
           
          </div>
          <div class="row col100">
            <a href="#!" class="btn" @click="addSection">Сохранить</a>
          </div>
        </div>
        <div class="icon">
          <img :src="imagePreview" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.ql-formats {
  display: inline-block !important;
}
.ql-picker-options {
  display: none;
}
.sectionList .icon img {
  object-fit: cover;
}
.col10 {
  width: 14.5%;
  .smallFont {
    font-size: 10px !important;
  }
}
.prev {
  position: relative;
  &.small {
    ul {
      top: 68px;
      left: 15px;
      right: 15px;
    }
  }
  ul {
    position: absolute;
    left: 20px;
    right: 20px;
    top: 52px;
    background: white;
    margin: 0;
    padding: 10px;
    font-size: 13px;
    border-bottom: 1px solid #501a98;
    border-left: 1px solid #501a98;
    border-right: 1px solid #501a98;
    z-index: 9;
    display: none;
    &.active {
      display: block;
    }

    li {
      padding: 3px 0;
      transition: 0.3s ease-out;
      &:hover {
        opacity: 0.7;
        cursor: pointer;
      }
    }
  }
}
</style>

<script>
import api from "@/components/app/api";
import DropDown from "@/components/app/dropDown";
import helper from "@/components/app/helper";
import Header from "@/components/app/header";
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';
export default {
  name: "Home",
  data() {
    return {
      imagePreview: "data:image/jpeg;base64,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",
      file: "",
      searchList: [],
      sailersList: [],
      sName: "",
      sParentId: 0,
      sParentName: "",
      parentSection: "",
      sTitle: "",
      sOverPrice: 0,
      sDescription: "",
      sSailer: 0,
      sIcon: "",
      sUrl: "",
      sParentUrl: "",
      sBanner: 0,
      id: 0,
      seoText: "",
      markup_0_3: 0,
      markup_3_5: 0,
      markup_5_7: 0,
      markup_7_10: 0,
      markup_10_15: 0,
      markup_15_20: 0,
      markup_20_25: 0,
      markup_25_30: 0,
      markup_30: 0
    };
  },
  watch: {
    id: function () {
      if(this.id!=0) {
        this.sget();
      }
    },
  },
  computed: {},

  methods: {
    toUrl() {
      this.sUrl = helper.methods.urlGenerator(this.sName)
      this.sTitle = `Купить ${this.sName.toLowerCase()} в Донецке (ДНР) - Tehnoland`
      this.sDescription = `${this.sName} в интернет-магазине Tehnoland, техника и электроника, доставка по Донецку и Макеевке, официальная гарантия!`
    },
    
    formNulled() {
        this.sName = "";
        this.sParentId = 0;
        this.sParentName = "";
        this.sTitle = "";
        this.sOverPrice = 0;
        this.sDescription = "";
        this.sSailer = 0;
        this.sIcon = "";
        this.imagePreview = "data:image/jpeg;base64,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"
        this.sUrl = "";
        this.sParentUrl = "";
        this.sBanner = 0;
        this.id = 0;

        console.log("sSailer ", this.sSailer);
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
      let reader = new FileReader();
      reader.addEventListener(
        "load",
        function () {
          this.imagePreview = reader.result;
        }.bind(this),
        false
      );
      if (this.file) {
        if (/\.(jpe?g|png|gif)$/i.test(this.file.name)) {
          reader.readAsDataURL(this.file);
        }
      }
    },
    setSailer(e) {
      this.sSailer = e.id;
    },
    async sget() {
      //Получаем инфо про категорию
      let response = await api.methods.SECTIONS_get({
        id: this.id,
      });
      if (Object.keys(response).length > 0) {
        this.sName = response.name;
        this.sParentId = response.parentSection;
        this.sParentName = response.parentSectionName;
        this.sTitle = response.title;
        this.sOverPrice = response.overPrice;
        this.sDescription = response.description;
        this.sSailer = response.sailer;
        this.sIcon = response.icon;
        this.seoText = response.seotext;
        this.$refs.myEditor.setHTML(this.seoText)
        if(response.icon!="") {
          this.imagePreview = `https://tehnoland.shop/uploads/${response.icon}`
        }
        this.sUrl = response.url;
        this.sParentUrl = response.sailerUrl;
        this.sBanner = response.banner;
        this.id = response.id;

        this.markup_0_3 = response.markup_0_3;
        this.markup_3_5 = response.markup_3_5;
        this.markup_5_7 = response.markup_5_7;
        this.markup_7_10 = response.markup_7_10;
        this.markup_10_15 = response.markup_10_15;
        this.markup_15_20 = response.markup_15_20;
        this.markup_20_25 = response.markup_20_25;
        this.markup_25_30 = response.markup_25_30;
        this.markup_30 = response.markup_30;
      }
    },
    closeUl() {
      console.log("closeUl");
      let arr = document.querySelectorAll(".prev ul");
      arr.forEach((e) => {
        e.classList.remove("active");
        this.searchList = [];
      });
    },

    async addSection() {
      if(this.imagePreview == `https://tehnoland.shop/uploads/${this.sIcon}` || this.imagePreview == `data:image/jpeg;base64,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`) {
        this.imagePreview = ""
      }

      let response = await api.methods.SECTIONS_add({
        name: this.sName,
        parentName: this.sParentId,
        title: this.sTitle,
        overPrice: this.sOverPrice,
        description: this.sDescription,
        sailer: this.sSailer,
        icon: this.imagePreview,
        url: this.sUrl,
        parentUrl: this.sParentUrl,
        banner: this.sBanner,
        seoText: this.seoText,
        id: this.id,
        markup_0_3: this.markup_0_3.trim(),
        markup_3_5: this.markup_3_5.trim(),
        markup_5_7: this.markup_5_7.trim(),
        markup_7_10: this.markup_7_10.trim(),
        markup_10_15: this.markup_10_15.trim(),
        markup_15_20: this.markup_15_20.trim(),
        markup_20_25: this.markup_20_25.trim(),
        markup_25_30: this.markup_25_30.trim(),
        markup_30: this.markup_30.trim()
      });
      this.formNulled()
      helper.methods.warning(response, "ok");
    },
    async searchSection(e) {
      let value = e.target.value;
      if (value.trim().length > 2) {
        this.searchList = await api.methods.SECTIONS_search({
          name: value,
        });
      }
      if (this.searchList.length > 0) {
        e.target.closest("div").querySelector("ul").classList.add("active");
      }
      console.log(this.searchList);
    },
    async SAILERS_list() {
      this.sailersList = await api.methods.SAILERS_list();
    },
  },
  async mounted() {
    this.SAILERS_list();
    const F = (e) => {
      if (e.target.closest(".prev ul") == null) {
        this.closeUl();
      }
    };
    document.addEventListener("click", F);
  },
  async created() {},
  components: {
    Header,
    DropDown,
    QuillEditor
  },
};
</script>